export default "__VITE_ASSET__Cs_yNMAQ__"